import { render, staticRenderFns } from "./SystemBubble.vue?vue&type=template&id=5ea909e2&scoped=true&"
import script from "./SystemBubble.vue?vue&type=script&lang=js&"
export * from "./SystemBubble.vue?vue&type=script&lang=js&"
import style0 from "./SystemBubble.vue?vue&type=style&index=0&id=5ea909e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea909e2",
  null
  
)

export default component.exports